import React, { createContext } from "react";

export const ProductsContext = createContext();

const ProductsContextProvider = (props) => {
  const type = [
    {
      id: 1,
      typeName: "Casual Shoes",
    },
    {
      id: 2,
      typeName: "Leather Shoes",
    },
    {
      id: 3,
      typeName: "Running Shoes",
    },
    {
      id: 4,
      typeName: "Floaters and Sandals",
    },
    {
      id: 5,
      typeName: "Sports Shoes",
    },
  ];

  const products = [
    {
      id: 1,
      productNo: 1,
      title: "Blue white spots casual shoes",
      category: 1,
      price: 1699,
      rating: 4.8,
      color: "White",
      discount: 30,
      size: [6, 7, 8, 9],
    },
    {
      id: 2,
      productNo: 2,
      title: "Brown lace casual shoes",
      category: 1,
      price: 1299,
      rating: 4.1,
      color: "Brown",
      discount: 0,
      size: [7, 8, 9, 10, 11],
    },
    {
      id: 3,
      productNo: 3,
      title: "Colorful casual shoes",
      category: 1,
      price: 1299,
      rating: 3.2,
      color: "Blue",
      discount: 30,
      size: [7, 8, 9, 10],
    },
    {
      id: 4,
      productNo: 4,
      title: "Grey with yellow lace casual shoes",
      category: 1,
      price: 899,
      rating: 2.9,
      color: "Black",
      discount: 45,
      size: [9, 10],
    },
    {
      id: 5,
      productNo: 5,
      title: "Blue long casual shoes",
      category: 1,
      price: 999,
      rating: 4.9,
      color: "Blue",
      discount: 25,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 6,
      productNo: 6,
      title: "Light blue cloth casual shoes",
      category: 1,
      price: 1399,
      rating: 4.5,
      color: "Blue",
      discount: 10,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 7,
      productNo: 7,
      title: "Black lace casual shoes",
      category: 1,
      price: 699,
      rating: 3.2,
      color: "Black",
      discount: 60,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 8,
      productNo: 8,
      title: "Blue lace casual shoes",
      category: 1,
      price: 2999,
      rating: 4.5,
      color: "Blue",
      discount: 60,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 9,
      productNo: 9,
      title: "Grey green casual shoes",
      category: 1,
      price: 1599,
      rating: 2.3,
      color: "Green",
      discount: 60,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 10,
      productNo: 10,
      title: "White light casual shoes",
      category: 1,
      price: 999,
      rating: 4.3,
      color: "White",
      discount: 20,
      size: [6, 7, 8, 9, 10, 11],
    },
    {
      id: 11,
      productNo: 11,
      title: "White red spots casual shoes",
      category: 1,
      price: 1299,
      rating: 3.2,
      color: "White",
      discount: 40,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 12,
      productNo: 12,
      title: "Black no lace casual shoes",
      category: 1,
      price: 799,
      rating: 4.3,
      color: "Black",
      discount: 12,
      size: [7, 8, 9, 10],
    },
    {
      id: 13,
      productNo: 1,
      title: "Black light leather shoes",
      category: 2,
      price: 2199,
      rating: 3.8,
      color: "Black",
      discount: 25,
      size: [6, 7, 8, 9, 10, 11],
    },
    {
      id: 14,
      productNo: 2,
      title: "White light leather shoes",
      category: 2,
      price: 4199,
      rating: 4.2,
      color: "White",
      discount: 12,
      size: [7, 8, 9, 10],
    },
    {
      id: 15,
      productNo: 3,
      title: "Brown leather shoes",
      category: 2,
      price: 4999,
      rating: 4.6,
      color: "Brown",
      discount: 40,
      size: [7, 8, 9, 10, 11],
    },
    {
      id: 16,
      productNo: 4,
      title: "Dark brown leather shoes",
      category: 2,
      price: 3999,
      rating: 4.1,
      color: "Brown",
      discount: 10,
      size: [7, 8, 9, 10],
    },
    {
      id: 17,
      productNo: 5,
      title: "Black hard base leather shoes",
      category: 2,
      price: 2599,
      rating: 2.8,
      color: "Black",
      discount: 50,
      size: [7, 8, 9],
    },
    {
      id: 18,
      productNo: 6,
      title: "Shine black leather shoes",
      category: 2,
      price: 2699,
      rating: 1.8,
      color: "Black",
      discount: 60,
      size: [7, 8, 9, 10],
    },
    {
      id: 19,
      productNo: 7,
      title: "Dust brown leather shoes",
      category: 2,
      price: 7999,
      rating: 4.8,
      color: "Brown",
      discount: 12,
      size: [6, 7, 8, 9, 10, 11],
    },
    {
      id: 20,
      productNo: 8,
      title: "Bright brown leather shoes",
      category: 2,
      price: 6999,
      rating: 4.2,
      color: "Brown",
      discount: 16,
      size: [6, 7, 8, 9, 10, 11],
    },
    {
      id: 21,
      productNo: 9,
      title: "Black brown leather shoes",
      category: 2,
      price: 2049,
      rating: 2.9,
      color: "Black",
      discount: 80,
      size: [7, 8, 9],
    },
    {
      id: 22,
      productNo: 10,
      title: "Black premium leather shoes",
      category: 2,
      price: 8999,
      rating: 4.9,
      color: "Black",
      discount: 10,
      size: [7, 8, 9, 10, 11],
    },
    {
      id: 23,
      productNo: 11,
      title: "Black school leather shoes",
      category: 2,
      price: 999,
      rating: 4.4,
      color: "Black",
      discount: 16,
      size: [6, 7, 8, 9],
    },
    {
      id: 24,
      productNo: 12,
      title: "Brown long leather shoes",
      category: 2,
      price: 5999,
      rating: 4.1,
      color: "Brown",
      discount: 16,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 25,
      productNo: 1,
      title: "Black running shoes",
      category: 3,
      price: 1299,
      rating: 4.3,
      color: "Black",
      discount: 0,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 26,
      productNo: 2,
      title: "Colorful spike running shoes",
      category: 3,
      price: 3999,
      rating: 4.6,
      color: "Green",
      discount: 10,
      size: [6, 7, 8, 9],
    },
    {
      id: 27,
      productNo: 3,
      title: "White high base running shoes",
      category: 3,
      price: 799,
      rating: 3.5,
      color: "White",
      discount: 30,
      size: [7, 8, 9, 10],
    },
    {
      id: 28,
      productNo: 4,
      title: "Dull black running shoes",
      category: 3,
      price: 899,
      rating: 2.4,
      color: "Black",
      discount: 40,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 29,
      productNo: 5,
      title: "White running shoes",
      category: 3,
      price: 399,
      rating: 1.6,
      color: "White",
      discount: 20,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 30,
      productNo: 6,
      title: "Red running shoes",
      category: 3,
      price: 1399,
      rating: 3.6,
      color: "Red",
      discount: 15,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 31,
      productNo: 7,
      title: "Green running shoes",
      category: 3,
      price: 1899,
      rating: 4.3,
      color: "Green",
      discount: 55,
      size: [7, 8, 9, 10],
    },
    {
      id: 32,
      productNo: 8,
      title: "Dark green running shoes",
      category: 3,
      price: 899,
      rating: 1.4,
      color: "Green",
      discount: 30,
      size: [7, 8, 9],
    },
    {
      id: 33,
      productNo: 9,
      title: "Orange white running shoes",
      category: 3,
      price: 1199,
      rating: 4.4,
      color: "White",
      discount: 10,
      size: [7, 8, 9, 10],
    },
    {
      id: 34,
      productNo: 10,
      title: "Black hard base running shoes",
      category: 3,
      price: 1399,
      rating: 3.2,
      color: "Black",
      discount: 30,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 35,
      productNo: 11,
      title: "Black white base running shoes",
      category: 3,
      price: 2999,
      rating: 4.4,
      color: "Black",
      discount: 70,
      size: [7, 8, 9, 10],
    },
    {
      id: 36,
      productNo: 12,
      title: "White broad running shoes",
      category: 3,
      price: 2199,
      rating: 4.2,
      color: "Black",
      discount: 5,
      size: [6, 7, 8, 9, 10, 11],
    },
    {
      id: 37,
      productNo: 1,
      title: "Brown Sandal",
      category: 4,
      price: 499,
      rating: 3.1,
      color: "Brown",
      discount: 20,
      size: [7, 8, 9, 10],
    },
    {
      id: 38,
      productNo: 2,
      title: "Brown sandal with hard base",
      category: 4,
      price: 799,
      rating: 3.9,
      color: "Brown",
      discount: 15,
      size: [7, 8, 9, 10],
    },
    {
      id: 39,
      productNo: 3,
      title: "Brown cloth shoes",
      category: 4,
      price: 999,
      rating: 4.5,
      color: "Brown",
      discount: 30,
      size: [7, 8, 9, 10],
    },
    {
      id: 40,
      productNo: 4,
      title: "Dark brown cloth shoes",
      category: 4,
      price: 2999,
      rating: 4.9,
      color: "Brown",
      discount: 80,
      size: [7, 8, 9, 10],
    },
    {
      id: 41,
      productNo: 5,
      title: "Black sandal with hard base",
      category: 4,
      price: 699,
      rating: 2.9,
      color: "Black",
      discount: 20,
      size: [7, 8, 9, 10, 11],
    },
    {
      id: 42,
      productNo: 6,
      title: "Brown sandal with soft base",
      category: 4,
      price: 1599,
      rating: 3.2,
      color: "Brown",
      discount: 18,
      size: [7, 8, 9, 10, 11],
    },
    {
      id: 43,
      productNo: 7,
      title: "Dark brown sandal",
      category: 4,
      price: 699,
      rating: 3.2,
      color: "Brown",
      discount: 0,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 44,
      productNo: 8,
      title: "Black fashion shoes",
      category: 4,
      price: 1199,
      rating: 4.2,
      color: "Black",
      discount: 30,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 45,
      productNo: 9,
      title: "Grey floaters",
      category: 4,
      price: 299,
      rating: 4.7,
      color: "Black",
      discount: 10,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 46,
      productNo: 10,
      title: "Grey shoes with blue lace",
      category: 4,
      price: 899,
      rating: 3.3,
      color: "Black",
      discount: 25,
      size: [6, 7, 8, 9],
    },
    {
      id: 47,
      productNo: 11,
      title: "Blue with no lace shoes",
      category: 4,
      price: 499,
      rating: 3.8,
      color: "Blue",
      discount: 0,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 48,
      productNo: 12,
      title: "Blue checks shoes",
      category: 4,
      price: 1099,
      rating: 3.3,
      color: "Blue",
      discount: 60,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 49,
      productNo: 1,
      title: "Grey sports shoes with soft base",
      category: 5,
      price: 1999,
      rating: 3.9,
      color: "Black",
      discount: 10,
      size: [6, 7],
    },
    {
      id: 50,
      productNo: 2,
      title: "Pink sports shoes",
      category: 5,
      price: 1299,
      rating: 4.4,
      color: "Pink",
      discount: 5,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 51,
      productNo: 3,
      title: "Blue sports shoes",
      category: 5,
      price: 1499,
      rating: 4.9,
      color: "Blue",
      discount: 10,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 52,
      productNo: 4,
      title: "Black sports shoes",
      category: 5,
      price: 999,
      rating: 4.1,
      color: "Black",
      discount: 25,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 53,
      productNo: 5,
      title: "Pink flat sports shoes",
      category: 5,
      price: 799,
      rating: 4.3,
      color: "Pink",
      discount: 15,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 54,
      productNo: 6,
      title: "Black flat sports shoes",
      category: 5,
      price: 699,
      rating: 3.8,
      color: "Black",
      discount: 35,
      size: [6, 7, 8, 9],
    },
    {
      id: 55,
      productNo: 7,
      title: "Black light sports shoes",
      category: 5,
      price: 1399,
      rating: 4.8,
      color: "Black",
      discount: 10,
      size: [6, 7, 8, 9, 10, 11],
    },
    {
      id: 56,
      productNo: 8,
      title: "Grey light sports shoes",
      category: 5,
      price: 1999,
      rating: 4.2,
      color: "Black",
      discount: 30,
      size: [9, 10, 11],
    },
    {
      id: 57,
      productNo: 9,
      title: "Dark blue sports shoes",
      category: 5,
      price: 1299,
      rating: 2.9,
      color: "Blue",
      discount: 20,
      size: [6, 7, 8, 9, 10, 11],
    },
    {
      id: 58,
      productNo: 10,
      title: "Dark blue waterproof sports shoes",
      category: 5,
      price: 1599,
      rating: 3.9,
      color: "Blue",
      discount: 10,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 59,
      productNo: 11,
      title: "Green sports shoes",
      category: 5,
      price: 899,
      rating: 3.1,
      color: "Green",
      discount: 30,
      size: [6, 7, 8, 9, 10],
    },
    {
      id: 60,
      productNo: 12,
      title: "Pink hard base shoes",
      category: 5,
      price: 1299,
      rating: 1.9,
      color: "Pink",
      discount: 90,
      size: [6, 7, 8, 9, 10],
    },
  ];
  return (
    <ProductsContext.Provider value={{ products, type }}>
      {props.children}
    </ProductsContext.Provider>
  );
};
export default ProductsContextProvider;
